import context from '@/context'
import getComponentKey from '@/utils/getComponentKey'
import { allowErrorDialog } from '@/utils/fetch'

const initialState = {
  fetching: false,
  adding: false,
  removing: false,
  attachmentsKey: getComponentKey(),
  outputReportGroup: null,
  reportUploadAdding: false,
  reportUploadRemoving: false,
  reportUploadApplying: false,
  reportUploadsKey: getComponentKey()
}

export const actionTypes = {
  fetching: 'outputReportGroup/fetching',
  fetched: 'outputReportGroup/fetched',
  attachmentAdding: 'outputReportGroup/attachment/adding',
  attachmentAdded: 'outputReportGroup/attachment/added',
  attachmentRemoving: 'outputReportGroup/attachment/removing',
  attachmentRemoved: 'outputReportGroup/attachment/removed',
  submitting: 'outputReportGroup/submitting',
  submitted: 'outputReportGroup/submitted',
  reportUploadAdding: 'outputReportGroup/reportUpload/adding',
  reportUploadAdded: 'outputReportGroup/reportUpload/added',
  reportUploadRemoving: 'outputReportGroup/reportUpload/removing',
  reportUploadRemoved: 'outputReportGroup/reportUpload/removed',
  reportUploadApplying: 'outputReportGroup/reportUpload/applying',
  reportUploadApplied: 'outputReportGroup/reportUpload/applied',
  error: 'outputReportGroup/error'
}

export const actionCreators = {
  get: (id) => (dispatch) => {
    dispatch({ type: actionTypes.fetching })
    context.api.outputReportGroupService.get(id, allowErrorDialog)
      .then(response => {
        dispatch({ type: actionTypes.fetched, data: response })
      }).catch(() => dispatch({ type: actionTypes.error, update: { fetching: false } }))
  },
  addAttachments: (input) => (dispatch) => {
    dispatch({ type: actionTypes.attachmentAdding })
    context.api.outputReportGroupService.addAttachments(input)
      .then(() => {
        dispatch({ type: actionTypes.attachmentAdded })
      }).catch(() => dispatch({ type: actionTypes.error, update: { adding: false } }))
  },
  removeAttachments: (input) => (dispatch) => {
    dispatch({ type: actionTypes.attachmentRemoving })
    context.api.outputReportGroupService.removeAttachments(input)
      .then(() => {
        dispatch({ type: actionTypes.attachmentRemoved })
      }).catch(() => dispatch({ type: actionTypes.error, update: { removing: false } }))
  },
  addReportUploads: (input) => (dispatch) => {
    dispatch({ type: actionTypes.reportUploadAdding })
    context.api.outputReportGroupService.addReportUploads(input)
      .then(() => {
        dispatch({ type: actionTypes.reportUploadAdded })
      }).catch(() => dispatch({ type: actionTypes.error, update: { reportUploadAdding: false } }))
  },
  removeReportUploads: (input) => (dispatch) => {
    dispatch({ type: actionTypes.reportUploadRemoving })
    context.api.outputReportGroupService.removeReportUploads(input)
      .then(() => {
        dispatch({ type: actionTypes.reportUploadRemoved })
      }).catch(() => dispatch({ type: actionTypes.error, update: { reportUploadRemoving: false } }))
  },
  applyReportUpload: (input) => (dispatch) => {
    dispatch({ type: actionTypes.reportUploadApplying })
    context.api.reportExportService.importReportTemplateFromExcelFile(input)
      .then(() => {
        dispatch({ type: actionTypes.reportUploadApplied })
      })
      .catch(() => dispatch({ type: actionTypes.error, update: { reportUploadApplying: false } }))
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.fetching: return { ...state, fetching: true }
    case actionTypes.fetched: return {
      ...state,
      fetching: false,
      outputReportGroup: action.data
    }
    case actionTypes.attachmentAdding: return { ...state, adding: true }
    case actionTypes.attachmentAdded: return { ...state, adding: false, attachmentsKey: getComponentKey() }
    case actionTypes.attachmentRemoving: return { ...state, removing: true }
    case actionTypes.attachmentRemoved: return { ...state, removing: false, attachmentsKey: getComponentKey() }
    case actionTypes.submitting: return {
      ...state,
      outputReportGroup: {
        ...state.outputReportGroup,
        isBeingSubmitted: true
      }
    }
    case actionTypes.submitted: return {
      ...state,
      outputReportGroup: {
        ...state.outputReportGroup,
        isBeingSubmitted: false
      }
    }

    case actionTypes.reportUploadAdding: return { ...state, reportUploadAdding: true }
    case actionTypes.reportUploadAdded: return { ...state, reportUploadAdding: false, reportUploadsKey: getComponentKey() }
    case actionTypes.reportUploadRemoving: return { ...state, reportUploadRemoving: true }
    case actionTypes.reportUploadRemoved: return { ...state, reportUploadRemoving: false, reportUploadsKey: getComponentKey() }
    case actionTypes.reportUploadApplying: return { ...state, reportUploadApplying: true }
    case actionTypes.reportUploadApplied: return { ...state, reportUploadApplying: false }
    case actionTypes.error: return { ...state, ...action.update }

    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/OutputReportGroup.js